import { Search, Compass, Code, Check } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const Services = () => {
  return <section id="services" className="section bg-grayLight text-darkText pt-16 md:pt-20 pb-[40px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-darkText">
            What I <span className="text-cyanPrimary">Offer</span>
          </h2>
          <p className="text-lg text-darkText/80 leading-relaxed">Strategic Product Leadership – Without the Full-Time Hire. I provide embedded product support on a fractional basis, tailored to your organization's unique needs.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          <Card className="bg-white border-cyanPrimary/10 shadow-card hover:shadow-premium transition-shadow rounded-2xl overflow-hidden">
            <CardHeader className="border-b border-grayMedium/20 pb-4 h-24 flex flex-row items-center">
              <Search size={24} className="text-cyan-400 min-w-6 mr-3" />
              <CardTitle className="text-darkText text-xl">Customer Discovery</CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-4 text-left">
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80">Map current customer journeys</p>
              </div>
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80 text-left">Surface insights from interviews, behavior, and trends</p>
              </div>
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80 text-left">Create actionable customer personas</p>
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-cyanPrimary/10 shadow-card hover:shadow-premium transition-shadow rounded-2xl overflow-hidden">
            <CardHeader className="border-b border-grayMedium/20 pb-4 h-24 flex flex-row items-center">
              <Compass size={24} className="text-cyan-400 min-w-6 mr-3" />
              <CardTitle className="text-darkText text-xl">Product Strategy</CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-4 text-left">
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80">Clarify your product's value proposition</p>
              </div>
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80 text-left">Design user flows, backend processes, and data integrations</p>
              </div>
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80 text-left">Define, prioritize, and sequence your MVP and long-term roadmap</p>
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-cyanPrimary/10 shadow-card hover:shadow-premium transition-shadow rounded-2xl overflow-hidden">
            <CardHeader className="border-b border-grayMedium/20 pb-4 h-24 flex flex-row items-center">
              <Code size={24} className="text-cyan-400 min-w-6 mr-3" />
              <CardTitle className="text-darkText text-xl">MVP Build Support</CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-4 text-left">
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80 text-left">Recommend no-code / low-code / custom platform options</p>
              </div>
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80 text-left">Collaborate with designers and engineers</p>
              </div>
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80 text-left">Write user stories and technical requirements</p>
              </div>
              <div className="flex items-start gap-3">
                <Check className="text-cyanPrimary min-w-5 mt-1" size={18} />
                <p className="text-darkText/80">Drive early user feedback and iteration</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};
export default Services;